import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"

const { Text } = Typography

/**
 * Compact mobile-friendly pagination for Health subpages.
 * Shows "Showing X–Y of Z results" and Prev/Next buttons.
 */
const HealthMobilePagination = ({ current, pageSize, total, onChange }) => {
  const { t } = useTranslation()

  if (!total) return null

  const totalPages = Math.ceil(total / pageSize)
  const from = (current - 1) * pageSize + 1
  const to = Math.min(current * pageSize, total)

  return (
    <Flex
      vertical
      gap={8}
      className="health-mobile-pagination"
      style={{ padding: "12px 16px 4px" }}
    >
      <Text type="secondary">
        {t("Showing")} <Text strong>{`${from}-${to}`}</Text> {t("of")} <Text strong>{total}</Text>{" "}
        {t("results")}
      </Text>
      <Flex gap={8}>
        <ButtonComponent
          style={{ flex: 1 }}
          disabled={current <= 1}
          onClick={() => onChange(current - 1)}
        >
          {t("Previous")}
        </ButtonComponent>
        <Text
          style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", padding: "0 4px" }}
        >
          {current} / {totalPages}
        </Text>
        <ButtonComponent
          style={{ flex: 1 }}
          disabled={current >= totalPages}
          onClick={() => onChange(current + 1)}
        >
          {t("Next")}
        </ButtonComponent>
      </Flex>
    </Flex>
  )
}

export default HealthMobilePagination
